import { STDRISK_INIT_FAIL, STDRISK_INIT_LOADING, STDRISK_INIT_SUCCESS, STDRISK_TEXT_INIT_LOADING, STDRISK_TEXT_INIT_SUCCESS, STDRISK_TEXT_INIT_FAIL, STDRISK_ITEMTEXT_INIT_LOADING, STDRISK_ITEMTEXT_INIT_SUCCESS, STDRISK_ITEMTEXT_INIT_FAIL } from '@/store/types'

export const stdRisk = {
  [STDRISK_INIT_LOADING](state) {
    state.stdRisk.init = 0
    state.stdRisk.initErr = []
    state.stdRisk.menu = {}
  },
  [STDRISK_INIT_SUCCESS](state, data) {
    state.stdRisk.init = 1
    state.stdRisk.initErr = []
    state.stdRisk.menu = data.menu
  },
  [STDRISK_INIT_FAIL](state, error) {
    state.stdRisk.init = 2
    state.stdRisk.initErr = error
    state.stdRisk.menu = {}
  },
  [STDRISK_TEXT_INIT_LOADING](state) {
    state.stdRisk.text.init = 0
    state.stdRisk.text.initErr = []
    state.stdRisk.text.menu = {}
  },
  [STDRISK_TEXT_INIT_SUCCESS](state, data) {
    state.stdRisk.text.init = 1
    state.stdRisk.text.initErr = []
    state.stdRisk.text.menu = data.menu
  },
  [STDRISK_TEXT_INIT_FAIL](state, error) {
    state.stdRisk.text.init = 2
    state.stdRisk.text.initErr = error
    state.stdRisk.text.menu = {}
  },
  [STDRISK_ITEMTEXT_INIT_LOADING](state) {
    state.stdRisk.itemText.init = 0
    state.stdRisk.itemText.initErr = []
    state.stdRisk.itemText.menu = {}
  },
  [STDRISK_ITEMTEXT_INIT_SUCCESS](state, data) {
    state.stdRisk.itemText.init = 1
    state.stdRisk.itemText.initErr = []
    state.stdRisk.itemText.menu = data.menu
  },
  [STDRISK_ITEMTEXT_INIT_FAIL](state, error) {
    state.stdRisk.itemText.init = 2
    state.stdRisk.itemText.initErr = error
    state.stdRisk.itemText.menu = {}
  }
}
